module.exports = __webpack_public_path__ + "static/media/semiconductors_2_mobile.2ae299ef.jpg";